export default {"src":"/uk/_next/static/media/icon-show.0630f008.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};